import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

class Button extends Component {
  static propTypes = {
    element: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.func,
      PropTypes.object,
    ]),
    buttonType: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    element: 'button',
    buttonType: '',
    className: '',
  };

  createButton = () => {
    const { element, buttonType, className, children, ...rest } = this.props

    const classNames = [
      'button',
      buttonType ? `-${buttonType}` : '',
      className || '',
    ].join(' ')

    const props = {
      className: classNames,
      ...rest,
    }

    return React.createElement(element, props, children)
  };

  render() {
    return <Fragment>{this.createButton()}</Fragment>
  }
}

export default Button
